import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Typography,
} from "@mui/material";
import React from "react";

import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import LocalLibraryRoundedIcon from "@mui/icons-material/LocalLibraryRounded";
import { NavLink, useNavigate } from "react-router-dom";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const Items = [
  {
    name: "Home",
    link: "/",
    icon: <HomeRoundedIcon className="sidebar-icon" />,
  },
  {
    name: "About",
    link: "/About",
    icon: <PersonRoundedIcon className="sidebar-icon" />,
  },
  {
    name: "Experience",
    link: "/Experience",
    icon: <LocalLibraryRoundedIcon className="sidebar-icon" />,
  },
  {
    name: "Projects",
    link: "/Projects",
    icon: <BusinessCenterRoundedIcon className="sidebar-icon" />,
  },
  {
    name: "Contact",
    link: "/Contact",
    icon: <ChatRoundedIcon className="sidebar-icon" />,
  },
];

export const Sidebar = () => {
  return (
    <div className="flex-col mt-20">

        <div className="logo">
          <img src="/assest/images/logo_second.png" alt="Pruthvi Patel" />
        </div>
      <div className="sidebar p-4 ">
        {Items.map((val, i) => {
          const { name, link, icon } = val;

          return (
            <div className="sidebar-box" key={i}>
              <NavLink
                to={link}
                className={({ isActive }) =>
                  isActive ? "link-highlight-active" : "link-highlight"
                }
              >
                <div className="sidebar-item">
                  {icon}
                  <Typography variant="body1" component="h6">
                    {name}
                  </Typography>
                </div>
              </NavLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const BottomNavigator = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  const handleClick = (link) => {
    handleClose();
    navigate(link);
  };


  return (
    <SpeedDial
      ariaLabel="SpeedDial routes"
      className="speedDial-btn"
      sx={{ position: "fixed", bottom: 16, right: 16 }}
      icon={<SpeedDialIcon icon={<MenuIcon/>} openIcon={<CloseIcon/>} />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {Items.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          tooltipOpen
          onClick={() => handleClick(action.link)}
        />
      ))}
    </SpeedDial>
  );
};
